import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import { PaymentTermsListContainer, Title } from "./PaymentTermsList.styled";
import AddEditPaymentTerms from "../AddEditPaymentTerms";
import "./PaymentTermsList.scss";

/**
 * Site List,
 * Path - /sites
 * @see See [Sites Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944008228/Company+view+page+-+Sites)
 * @component
 */
const PaymentTermsList = (props) => {
  const { t, columnList, countries } = props;

  const [isAddPaymentTermsPopupVisible, setAddPaymentTermsPopupVisible] =
    useState(false);
  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewPaymentTerms = () => {
    setAddPaymentTermsPopupVisible(true);
  };
  const closePaymentTermsCreationPopup = () => {
    setAddPaymentTermsPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <PaymentTermsListContainer className="paymentTerms-list">
      <Title>{t("PAYMENT_TERMS")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewPaymentTerms={createNewPaymentTerms}
        countries={countries}
      />
      {isAddPaymentTermsPopupVisible && (
        <AddEditPaymentTerms
          title={t("PAYMENT_TERMS")}
          onClose={closePaymentTermsCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </PaymentTermsListContainer>
  );
};

PaymentTermsList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

PaymentTermsList.defaultProps = {
  columnList: [],
};

export default withTranslation()(PaymentTermsList);
